/**
 *  {
 *    OTHER: [<Question>, ...n],
 *    [questionSpecialName]: [<Question>, ...n]
 *  }
 */
export const groupReviewQuestionsBySpecialNames = (
  questions,
  specialNamesArr
) => {
  const questionGroups = {
    OTHER: [],
  };

  specialNamesArr.forEach((specialName) => {
    questionGroups[specialName] = [];
  });

  if (!questions) {
    return questionGroups;
  }

  if (!Array.isArray(specialNamesArr)) {
    questionGroups.OTHER = questions;
    return questionGroups;
  }

  // Group questions
  questions.forEach((question) => {
    const { questionSpecialName } = question;

    if (
      !questionSpecialName ||
      !specialNamesArr.includes(questionSpecialName)
    ) {
      questionGroups.OTHER.push(question);
      return;
    }

    // specialNamesArr includes currente question specialName
    if (!questionGroups[questionSpecialName]) {
      questionGroups[questionSpecialName] = [];
    }

    questionGroups[questionSpecialName].push(question);
  });

  return questionGroups;
};

// { text: 'test', averageRating: 4 }
export const getAverageReviewsRatings = (reviewOrReviews, locale) => {
  const averageRatings = [];
  const averageRatingsData = [];

  const loopVariable = Array.isArray(reviewOrReviews)
    ? reviewOrReviews
    : [reviewOrReviews];

  loopVariable.forEach((review) => {
    const ratingQuestions = review.questions.filter(
      (question) => question.questionType === 'RATING'
    );

    ratingQuestions.forEach((ratingQuestion) => {
      const { answerText } = ratingQuestion;
      const questionText = ratingQuestion.questionText[locale];

      if (typeof answerText !== 'number' || !questionText) {
        return;
      }

      const ratingsDataIndex = averageRatingsData.findIndex(
        (data) => data.text === questionText
      );

      if (ratingsDataIndex === -1) {
        averageRatingsData.push({ text: questionText, ratings: [answerText] });
      } else {
        averageRatingsData[ratingsDataIndex].ratings.push(answerText);
      }
    });
  });

  // Do calculations
  averageRatingsData.forEach((data) => {
    const totalRating = data.ratings.reduce(
      (prev, curr) => prev + Number(curr),
      0
    );

    const averageRating = Number(
      (totalRating / data.ratings.length).toFixed(2)
    );

    averageRatings.push({ text: data.text, averageRating });
  });

  return averageRatings;
};
